import { render, staticRenderFns } from "./homemsg.vue?vue&type=template&id=12b60602&scoped=true&"
import script from "./homemsg.vue?vue&type=script&lang=js&"
export * from "./homemsg.vue?vue&type=script&lang=js&"
import style0 from "./homemsg.vue?vue&type=style&index=0&id=12b60602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b60602",
  null
  
)

export default component.exports